export const gptUrl = 'https://www.googletagservices.com/tag/js/gpt.js';
